<template>
  <round :device="device" :isClose="false">
    <div>
      <img :src="state" style="width: 70px"/>
    </div>
    <div slot="footer" class="footer">
      <div @click="changeState('open')">
        <div>
          <img :src="icon.open" style="width: 55px"/>
        </div>
        <div>
          <span>打开</span>
        </div>
      </div>
      <div @click="changeState('paused')">
        <div>
          <img :src="icon.paused" style="width: 55px">
        </div>
        <div>
          <span>暂停</span>
        </div>
      </div>
      <div @click="changeState('close')">
        <div>
          <img :src="icon.close" style="width: 55px"/>
        </div>
        <div>
          <span>关闭</span>
        </div>
      </div>
    </div>
  </round>
</template>
<script>
import Round from './Round'
import { Message } from 'element-ui'
import api from '../model/device'

export default {
  name: 'Curtain',
  data () {
    return {}
  },
  props: {
    device: {
      type: Object,
      required: true,
      default () {
        return {}
      }
    }
  },
  computed: {
    state () {
      if (this.device.state.state) {
        return require('../assets/images/device/curtain/device_curtain_e.png')
      } else {
        return require('../assets/images/device/curtain/device_curtain.png')
      }
    },
    icon () {
      let icon = {
        open: require('../assets/images/device/curtain/dk.png'),
        paused: require('../assets/images/device/curtain/zt.png'),
        close: require('../assets/images/device/curtain/gb.png')
      }
      if (this.device.state.state === 2) {
        icon.close = require('../assets/images/device/curtain/gb-k.png')
      } else if (this.device.state.state === 1) {
        icon.open = require('../assets/images/device/curtain/dk-k.png')
      } else if (this.device.state.state === 0) {
        icon.paused = require('../assets/images/device/curtain/zt-k.png')
      }
      return icon
    }
  },
  components: {
    Round
  },
  methods: {
    async changeState (state) {
      try {
        await api.singleControl(this.device, state)
      } catch (e) {
        Message.error(e.message)
      }
    }
  }
}
</script>
<style scoped lang="less">
.round {
  .footer {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    text-align: center;
    font-size: 12px;
    font-weight: 400;
    color: rgba(89, 89, 89, 1);
    > div > div {
      height: 55px;
    }
    img {
      cursor: pointer;
    }
  }
}
</style>
